import { useMemo } from "react";
import {
  useGetVtransactionQuery,
  useGetVtransactionsQuery,
} from "./vtransactionEndpoints";
import { Vtransaction } from "../../entities/vtransaction";

type GetVtransactionsParams = Parameters<typeof useGetVtransactionsQuery>[0];
type GetVtransactionsOptions = Parameters<typeof useGetVtransactionsQuery>[1];

export function useVtransaction(vtransactionID: number | undefined) {
  const vtransactionQuery = useGetVtransactionQuery(vtransactionID ?? 0, {
    skip: (vtransactionID ?? 0) <= 0,
  });
  const vtransactionEntity = vtransactionQuery.data;

  return useMemo(() => {
    const ret: typeof vtransactionQuery & {
      vtransaction?: Vtransaction | undefined;
    } = {
      ...vtransactionQuery,
    };
    if (vtransactionEntity)
      ret.vtransaction = new Vtransaction(vtransactionEntity);
    return ret;
  }, [vtransactionEntity]);
}

export function useVtransactions(
  params?: GetVtransactionsParams,
  options?: GetVtransactionsOptions
) {
  const vtransactionQuery = useGetVtransactionsQuery(params, options);
  const vtransactionEntitiesMap = vtransactionQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof vtransactionQuery & {
      vtransactions?: Vtransaction[];
      vtransactionsMap?: { [id: number]: Vtransaction };
    } = {
      ...vtransactionQuery,
      vtransactions: [],
      vtransactionsMap: {},
    };
    if (vtransactionEntitiesMap) {
      const vtransactions: Vtransaction[] = [];
      const vtransactionsMap: { [id: number]: Vtransaction } = {};

      for (const key in vtransactionEntitiesMap) {
        if (
          Object.prototype.hasOwnProperty.call(vtransactionEntitiesMap, key)
        ) {
          const c = vtransactionEntitiesMap[key];
          const vtransaction = new Vtransaction(c);
          vtransactions.push(vtransaction);
          vtransactionsMap[vtransaction.id] = vtransaction;
        }
      }
      ret.vtransactions = vtransactions;
      ret.vtransactionsMap = vtransactionsMap;
    }

    return ret;
  }, [vtransactionEntitiesMap]);
}
